/* ═══════════════════════════════════════════════════════════════════
 *  Kidzio — bundled entry (the ONE webpack-bundled JS file)
 *
 *  TABLE OF CONTENTS
 *  ───────────────────────────────────────────────────────────────
 *    Imports (CSS + Swiper)       ................... line 19
 *    Expose Swiper as window.*     ................... line 25
 *    Service worker registration   ................... line 28
 *    Bottom-nav active state       ................... line 37
 *      · navMap (filename → nav id)
 *      · DOMContentLoaded activator (line 61)
 *
 *  HtmlWebpackPlugin auto-injects this as
 *  <script defer src="index.js"> at the bottom of every page, so
 *  `window.Swiper` / `window.SwiperModules` are available after
 *  DOMContentLoaded (not at page-script parse time).
 * ═══════════════════════════════════════════════════════════════════ */

import "../css/index.css";
import Swiper from "swiper";
import { Navigation, Pagination, FreeMode } from "swiper/modules";

// Expose Swiper globally so page scripts (loaded as plain <script src>)
// can instantiate sliders without their own import path.
window.Swiper = Swiper;
window.SwiperModules = { Navigation, Pagination, FreeMode };

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("assets/js/service-worker.js")
      .catch(() => {});
  });
}

// Bottom nav active highlight
const currentPath = window.location.pathname.split("/").pop() || "index.html";
const navMap = {
  "home.html": "nav-home",
  "home-streak.html": "nav-home",
  "home-rewards.html": "nav-home",
  "home-continue.html": "nav-home",
  "home-mission.html": "nav-home",
  "learn-categories.html": "nav-learn",
  "learn-math.html": "nav-learn",
  "learn-alphabet.html": "nav-learn",
  "learn-animals.html": "nav-learn",
  "learn-knowledge.html": "nav-learn",
  "learn-words.html": "nav-learn",
  "learn-opposites.html": "nav-learn",
  "rewards-dashboard.html": "nav-rewards",
  "leaderboard.html": "nav-ranking",
  "ranking-weekly.html": "nav-ranking",
  "ranking-friends.html": "nav-ranking",
  "league.html": "nav-ranking",
  "profile.html": "nav-profile",
  "edit-profile.html": "nav-profile",
  "settings.html": "nav-profile",
};

document.addEventListener("DOMContentLoaded", () => {
  const activeId = navMap[currentPath];
  if (activeId) {
    const activeEl = document.getElementById(activeId);
    if (activeEl) activeEl.classList.add("active");
  }
});
